<span
  class="app-inline-loader"
  [class.app-inline-loader--active]="active"
  [attr.aria-hidden]="active ? null : 'true'"
>
  <ng-container *ngIf="active">
    <mat-spinner
      class="app-inline-loader__spinner"
      [diameter]="diameter"
      [attr.aria-label]="ariaLabel"
    ></mat-spinner>

    <span *ngIf="showLabel && label" class="app-inline-loader__label">
      {{ label }}
    </span>
  </ng-container>
</span>
